import {useNavigate} from "react-router-dom";
import {cancelAppointmentModal as strings} from "strings";

import Button from "components/Button";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import {useCancelAppointment} from "liberty-core/api/react-query/appointment";

import styles from "./CancelAppointmentModal.module.css";

type Props = {
  visible: boolean;
  onClickClose: () => void;
  appointmentId: string;
  patientId: string;
};

export default function CancelAppointmentModal(props: Props) {
  const {mutateAsync: cancelAppointment, isLoading} = useCancelAppointment({
    appointmentId: props.appointmentId,
    patientId: props.patientId,
  });
  const navigate = useNavigate();

  return (
    <StyledModal
      visible={props.visible}
      className={styles.styledModal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.modalContent}>
        <PageTitle className={styles.pageTitle}>
          {strings.confirmCancelation}
        </PageTitle>
        <div className={styles.warningText}>{strings.confirmText}</div>
        <Button
          className={styles.cancelAppointmentButton}
          loading={isLoading}
          onClick={() => {
            cancelAppointment({
              appointmentId: props.appointmentId,
              patientId: props.patientId,
            })
              .then(() => navigate("/appointments"))
              .catch((err) =>
                alert(
                  err?.response?.data?.generic?.join("\n") ??
                    strings.cancelError,
                ),
              );
          }}
        >
          {strings.cancelAppointment}
        </Button>
        <Button
          className={styles.keepAppointmentButton}
          variant="unfilled"
          disabled={isLoading}
          onClick={props.onClickClose}
        >
          {strings.keepAppointment}
        </Button>
      </div>
    </StyledModal>
  );
}
